export default __webpack_public_path__ + "3c6aa1e6e807eb954c76be7cc4092c9f.png";